import React, {useState, useEffect, createContext} from 'react';
import './index.css';
import Home from './components/home';
import Login from './components/login';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Users from './components/users';
import Delegues from './components/delegues';
import QRScan from './components/QRscan';
import Sessions from './components/sessions';
import RealTimePresence from './components/RLpresence';
import BeneficiaireRepas from './components/beneficiaresRepas';
import RealTimeVote from './components/RLvotes';
import MultiQRCodeScanner from './components/scannVote';

export const theme = createTheme({
    status: {
      danger: '#e53e3e',
      error: '#96031A'
    },
    typography:{
      subtitle1:{
        fontSize:16,
        fontWeight:'bold'
      },
      body1:{
        fontSize:15
      },
      info:{
        fontSize:13
      }
    },
    palette: {
      primary: {
        main: '#255760',
        darker: '#1B3E45',
        background:'rgba(37, 87, 96,0.5)'
      },
      warning: {
        main: '#D5A021',
      },
      action:{
        hover: 'rgba(37, 87, 96, 0.1)'
      },
      neutral: {
        main: '#fff',
        contrastText: '#000',
      },
      turquoise: {
        main: '#79E1D5',
        contrastText: '#FFF'
      },
      valide: {
        main: '#5da271',
        contrastText: '#FFF'
      },
      verdigris: {
        main: '#51B2A7',
        contrastText: '#FFF'
      },
      purple: {
        main: '#BF49A5',
        contrastText: '#FFF'
      },
      carmine: {
        main: '#96031A',
        contrastText: '#FFF',
        background: 'rgba(150, 3, 26, 0.5)'
      },
      grey: {
        main: '#BCC9C7',
        contrastText: "#000"
      },
      dark: {
        main: '#000',
        contrastText: "#FFF"
      }
    },
    components:{
      MuiTableCell:{styleOverrides:{
        head: {
          backgroundColor: "#50787F",
          color: '#fff'
        },
        root:{
          fontSize:14
        }
      }},
      MuiTableRow: {styleOverrides:{
        root:{
          '&:nth-of-type(even)':{
            backgroundColor:"rgba(37, 87, 96, 0.05)"
          }
        },
      }}
    }
});
export const Context = createContext()

const routes = [
  {path:"/users", element: <Users/>},
  {path:"/delegues", element: <Delegues/>},
  {path:"/sessions", element: <Sessions/>},
  {path:"/scan", element: <QRScan/>},
  {path:"/scan_vote", element: <MultiQRCodeScanner/>},
  {path:"/realtime_presence/:sessionId", element: <RealTimePresence/>},
  {path:"/beneficiaires_repas", element: <BeneficiaireRepas/>},
  {path:"/votes", element: <RealTimeVote/>}
]

const unlogged_router = createBrowserRouter([
  {path:"/", element: <Login/>},
  {path:"*", element: <Login/>}
])

export default function App() {
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [isConnect, setConnect] = useState(Boolean(sessionStorage.getItem("token")))
  const [agentAccess, setAccess] = useState(JSON.parse(sessionStorage.getItem('user'))?.access??[])

  function updateConnect(newValue) {
    setConnect(newValue)
  }

  // useEffect(()=>{
  //   const user = sessionStorage.getItem('user')
  //   if (isConnect&&user) {
  //     const access = JSON.parse(user).access
  //     setAccess(typeof access === 'object' ? access : [])
  //   }
  // }, [isConnect])

  return(
    <Context.Provider value={{ isConnect, updateConnect, agentAccess, setAccess }} >
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <RouterProvider router={isConnect ? createBrowserRouter([{path:"/", element: <Home/>}, ...routes.filter(route=> user?.access.includes(route.path)), {path:"*", element: <Home/>}]): unlogged_router}/>
        </React.StrictMode>
      </ThemeProvider>
    </Context.Provider>
  );

}